import React, { useContext, useState } from 'react';
import { EllipsisOutlined } from '@ant-design/icons';
import { Badge, Button } from 'antd';

import SurveyContext from '@totem/components/surveyV2/instanceDetail/SurveyInstanceContext';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import colors from '@totem/styles/colors';
import fonts from '@totem/styles/fonts';
import {
  getBadgeStatus,
  getHealthStatusString,
} from '@totem/utilities/healthUtilities';

import '../survey.css';

const styles = {
  icon: {
    cursor: 'pointer',
    color: colors.opacity.black0_4,
    fontSize: fonts.fontLg,
  },
};

const HealthCard = () => {
  const [showHealthModal, setShowHealthModal] = useState<boolean>(false);
  const [showHealthHistoryModal, setShowHealthHistoryModal] =
    useState<boolean>(false);

  const { data } = useContext(SurveyContext);
  const { health } = data;
  return (
    <>
      <IBCard title="Health" variant="borderless">
        <div styleName="current-health">
          <div styleName="current-health-status">
            <Badge
              status={getBadgeStatus(health)}
              className="health-status-badge-sm"
            />
            <div styleName="health-status-option">
              {getHealthStatusString(health)}
            </div>
          </div>
          <EllipsisOutlined
            style={styles.icon}
            onClick={() => setShowHealthModal(!showHealthModal)}
          />
        </div>
        <div styleName="current-health-comment">
          {health ? health.comment : ''}
        </div>
        <div styleName="health-history-button">
          <Button
            onClick={() => setShowHealthHistoryModal(!showHealthHistoryModal)}
          >
            View all health history
          </Button>
        </div>
      </IBCard>
    </>
  );
};

export default HealthCard;
